import React from "react";
import ProductSidebar from "../../components/ProductSidebar";
import GoldPriceTable from "../../components/GoldPriceTable";
import SearchForm from "../../components/SearchForm";

const HomePage = () => (
  <div className="3_6_3" id="main-content" role="main">
    <div className="flex md:flex-row flex-col">
      <ProductSidebar />
      <div className="col-md-6 w-full md:w-1/2 px-4">
        <GoldPriceTable />
      </div>
      <SearchForm />
    </div>
  </div>
);

export default HomePage;
